// extracted by mini-css-extract-plugin
export default {"fullScreen":"FullScreen_fullScreen__EeHJV"};